<template lang="pug">
  .columns
    .column.is-4.is-offset-2
      br
      .box
        b-tooltip(
        :active="showTooltip" :animated="true" label="Drag and drop a square picture of you here" type="is-dark" always="" position="is-right")
          figure.avatar
            img(:src="picture" width="98" height="98")
        vue-dropzone#picture_dropzone(ref="dropzone" :options="dropOptions" :include-styling="false" @vdropzone-success="pictureUploaded" @vdropzone-error="pictureUploadError")
        .message.is-danger(v-if="error")
          .message-body
            | {{ error }}
        h2 {{ name }}
        h3.is-size-7 {{ location }}
        hr
        .columns
          .column
            b-field.has-text-left(label="First name")
              b-input#first_name(v-model="user.first_name" @keyup.native="delayedSave")
          .column
            b-field.has-text-left(label="Last name")
              b-input#last_name(v-model="user.last_name" @keyup.native="delayedSave")
        .columns
          .column
            b-field.has-text-left(label="City")
              b-input#city(v-model="user.city" @keyup.native="delayedSave")
          .column
            b-field.has-text-left(label="Country")
              b-input#country(v-model="user.country" @keyup.native="delayedSave")
        .columns
          .column.has-text-left
            b-field(label="Time zone")
              time-zone-select(v-model="user.time_zone")
        b-field.has-text-left(label="Email")
          b-input#email(v-model="user.email" type="text" required="" size="is-medium" placeholder="Email")
        b-field.has-text-left(label="New password")
          b-input#password(v-model="user.newPassword" type="password" size="is-medium")
        .columns
          .column
            b-field.has-text-left(label="Subscription")
              span.input.is-medium.is-disabled
                | {{ user.role }}
          .column.is-narrow(v-if="user.subscription_uid")
            button#btn_cancel_subscription.button.is-light.is-medium(v-confirm="{ok: cancelSubscription, okText: 'Cancel the subscription', cancelText: 'Back', cancel: noop, message: 'Are you sure you want to <b>cancel your subscription</b>?<br>You will still benefit from your subscription perks for the paid period'}")
              | Cancel
          .column.is-narrow(v-if="!user.subscription_uid && user.role == 'basic'")
            button#btn_canceled_subscription.button.is-light.is-medium(disabled="disabled")
              | Canceled
        button#btn_save_profile.button.is-block.is-primary.is-medium.is-fullwidth(:class="{'is-loading': isLoading, 'is-disabled': isLoading, 'is-success': isSuccess}" @click.stop.prevent="save")
          b-icon(v-if="isSuccess" icon="check")
          span(v-else="")
            | Save

</template>


<script>
import { nodeApi } from "@/config";
import { mapGetters } from "vuex";
import { User } from "@/store/models/resources";
import vue2Dropzone from "vue2-dropzone";
import map from "lodash/map";
import difference from "lodash/difference";
import sortBy from "lodash/sortBy";
import findIndex from "lodash/findIndex";

const getTemplate = () => `
<div class="dz-preview dz-file-preview">
  <div class="dz-image">
    <div data-dz-thumbnail-bg></div>
  </div>
  </div>
  `;

export default {
  name: "MyAccount",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropOptions: {
        url: `${nodeApi}/users/${this.$auth.user().id}`,
        headers: { Authorization: `Bearer ${this.$auth.token()}` },
        method: "put",
        maxFilesize: 1,
        previewTemplate: getTemplate()
      },
      isConnecting: false,
      error: null,
      isLoading: false,
      isSuccess: false,
      showTooltip: false,
      user: {}
    };
  },
  computed: {
    ...mapGetters(["apiUrl"]),
    name() {
      return (
        this.user.name ||
        `${this.user.first_name || ""} ${this.user.last_name || ""}`
      );
    },
    location() {
      if (
        this.user.city &&
        this.user.city.length &&
        this.user.country &&
        this.user.country.length
      ) {
        return `${this.user.city}, ${this.user.country}`;
      }
    },
    picture() {
      if (
        this.user.picture &&
        (this.user.picture.substring(0, 4) === "data" ||
          this.user.picture.substring(0, 4) === "http")
      )
        return this.user.picture;
      else if (this.user.picture) return `${this.apiUrl}/${this.user.picture}`;
      else return "/static/logo-frequency-list.png";
    },
    remainingQuantities() {
      const available = [3,4,5,8,10]
      const used = map(this.user.discounts, 'quantity')
      return difference(available, used);
    },
    sortedDiscounts() {
      if (!this.user.discounts || !this.user.discounts.length) {
        return []
      }
      return sortBy(this.user.discounts, ['quantity'])
    }
  },
  created() {
    // console.log('user: ', this.$auth.check())
    // console.log('user: ', this.$auth.user())
    // this.user = Object.assign({}, this.$auth.user())
    this.user = this.$auth.user();
    if (!this.user.picture) {
      var cpnt = this;
      setTimeout(() => {
        cpnt.showTooltip = true;
      }, 400);
      setTimeout(() => {
        cpnt.showTooltip = false;
      }, 4000);
    }

  },
  mounted() {
    console.log(this.$route)
    if (this.$route.query && this.$route.query.code) {
      this.isConnecting = true
      User.stripeConnect(this.$route.query).then((data) => {
        console.log(data)
        if (data.body.user) {
          this.$store.dispatch("setUser", data.body.user);
          this.$auth.user(data.body.user);
          this.user = data.body.user
        }
        this.isConnecting = false
      })
    }
  },
  methods: {
    delayedSave: _.debounce(function() {
      console.log("delaying");
      this.save();
    }, 700),
    save() {
      this.isLoading = true;
      this.$store.dispatch("saveUser", this.user).then(data => {
        this.$store.dispatch("setUser", data.user);
        this.$auth.user(data.user);
        this.isLoading = false;
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 2500);
      });
    },
    pictureUploaded(file) {
      console.log(file);
      this.user.picture = file.dataURL;
    },
    pictureUploadError(file, message, xhr) {
      console.log(file, message, xhr);
      this.$toast.open({
        duration: 5000,
        message: message,
        type: "is-danger"
      });
    },
    noop() {},
  }
};
</script>


<style scoped>
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}

input {
  font-weight: 300;
}

p {
  font-weight: 700;
}

p.subtitle {
  padding-top: 1rem;
}

a {
  text-decoration: none;
}
.equal-height {
  padding: 15px 0;
}

#btn_canceled_subscription,
#btn_cancel_subscription {
  margin-top: 30px;
}

.container {
  width: 400px;
  margin-top: 100px;
}

.dz-drag-hover {
  border: 2px dashed #dedede;
  background-color: rgba(240, 248, 255, 0.34);
}

.tooltip.is-right:before,
.tooltip.is-right:after {
  top: -30%;
}

#picture_dropzone {
  position: relative;
  z-index: 10;
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin: -126px auto 0px;
}

.connect-button {
  display: inline-block;
  margin-bottom: 1px;
  background-image: -webkit-gradient(linear,left top,left bottom,from(#28a0e5),to(#015e94));
  background-image: linear-gradient(#28a0e5,#015e94);
  -webkit-font-smoothing: antialiased;
  border: 0;
  padding: 1px;
  height: 32px;
  text-decoration: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,.2);
  box-shadow: 0 1px 0 rgba(0,0,0,.2);
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none!important;
  width: 200px;
  height: 32px;
  img {
    width: 100%;
    height: 32px;
  }
}
.discount_quantity,
.discount_percent {
  width: 43px;
}

.discounts input,
.discounts .control {
  font-size: 12px;
  line-height: 26px;
  margin-right: 3px !important;
  margin-left: 2px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/MyAccount.vue